import _ from '../../core/utils'

const CASES_CONFIG = {
    section: _.select( '.section--cases-content' ),
    search: {
        form: _.select( '.section--cases-content form' ),
        input: _.select( '.section--cases-content form input' ),
        clear: _.select( '.section--cases-content .search__clear' ),
        loader: _.select( '.section--cases-content .search__loader' ),
        submit: _.select( '.section--cases-content .search__submit' )
    },
    filter: _.select( '.section--cases-content select' ),
    grid: {
        wrap: _.select( '.section--cases-content .fl__card-grid' ),
        items: _.selectAll( '.section--cases-content .fl__card--case' ),
        noresults: _.select( '.section--cases-content .fl__card--noresults' )
    },
    endpoint: 'cases/search/'
}

export default CASES_CONFIG